import * as React from 'react';
import { makeStyles, Theme } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import { IAppModal } from '../../common/types';


interface AppModalProps extends React.Props<any>, IAppModal {
    closeAppModal():void;
};

const useStyles = makeStyles((theme: Theme) =>
    ({
        root: {
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 400,
            backgroundColor: theme.palette.primary.light,
            boxShadow: theme.shadows[5],
            padding: theme.spacing(2, 4, 3),
        },
    }),
);

function AppModal(props: AppModalProps): JSX.Element {
    const classes = useStyles();
    const createBody = () => {
        return (
            <div className={classes.root}>
                <h2 id="simple-modal-title">{props.title}</h2>
                <p id="simple-modal-description">
                    {props.message}
                 </p>
            </div>
        );
    }

    return (
            <Modal
            open={props.isAppModalOpened}
            aria-labelledby="simple-modal-title"
            aria-describedby="simple-modal-description"
            onClose={() => props.closeAppModal()}
            >
                {createBody()}
            </Modal>
    );
}


export default AppModal;
